import { render } from "./AppMessage.vue?vue&type=template&id=e3e0da96"
import script from "./AppMessage.vue?vue&type=script&lang=js"
export * from "./AppMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__